import React from "react";
import type { JobStatus } from "../../../type";

const STYLES: Record<JobStatus, string> = {
  pending: "bg-gray-100 text-gray-700",
  scheduled: "bg-indigo-100 text-indigo-700",
  running: "bg-blue-100 text-blue-700",
  succeeded: "bg-green-100 text-green-700",
  failed: "bg-red-100 text-red-700",
  canceled: "bg-yellow-100 text-yellow-800",
};

const JobStatusBadge: React.FC<{ status: JobStatus }> = ({ status }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded ${STYLES[status]}`}
  >
    {status}
  </span>
);

export default JobStatusBadge;
